import {FormBuilder, FormGroup} from '@angular/forms';
import {UniversalSearchModel} from 'src/app/core/models/universal-search.model';
import {transformations} from './searchModelTransformations';
import { isArray, isEmpty, isEqual, isNull, isObject, isUndefined, omit, omitBy } from 'lodash-es';
import { IncludeExcludeFiltersModel } from '../../../shared/dto';
import { DepartmentSizeFilterModel } from '../../sidebar/models';
import { FundingFilterTypeEnum } from 'src/app/shared/enums';
import { FundingRoundsEnum } from '../../sidebar/enums/funding-rounds.enum';

export class SearchModelForm {
    private form: FormGroup;

    constructor(
        private fb: FormBuilder
    ) {
        this.form = this.createFormGroup(UniversalSearchModel);
    }

    private setValue(field, value) {
        const fieldTransformations = transformations[field] || [];
        let transformedValue = value;
        fieldTransformations.forEach((transform) => {
            transformedValue = transform(transformedValue);
        });
        this.form.controls[field].setValue(transformedValue);
    }

    set request_type(val) {
        this.setValue('request_type', val);
    }

    get request_type() {
        return this.form.controls.request_type.value;
    }

    set lists(val) {
        this.setValue('lists', val);
    }

    get lists() {
        return this.form.controls.lists.value;
    }

    set contact_lists(val) {
        this.setValue('contact_lists', val);
    }

    get contact_lists() {
        return this.form.controls.contact_lists.value;
    }

    set suppression_lists(val) {
        this.setValue('suppression_lists', val);
    }

    get suppression_lists() {
        return this.form.controls.suppression_lists.value;
    }

    set rodId(val) {
        this.setValue('rodId', val);
    }

    get rodId() {
        return this.form.controls.rodId.value;
    }

    set match_ids(val) {
        this.setValue('match_ids', val);
    }

    get match_ids() {
        return this.form.controls.match_ids.value;
    }

    set company_naics_codes(val) {
        this.setValue('company_naics_codes', val);
    }

    get company_naics_codes() {
        return this.form.controls.company_naics_codes.value;
    }

    set company_naics_codes_none(val) {
        this.setValue('company_naics_codes_none', val);
    }

    get company_naics_codes_none() {
        return this.form.controls.company_naics_codes_none.value;
    }

    set company_naics_codes_all(val) {
        this.setValue('company_naics_codes_all', val);
    }

    get company_naics_codes_all() {
        return this.form.controls.company_naics_codes_all.value;
    }

    set company_sic_codes(val) {
        this.setValue('company_sic_codes', val);
    }

    get company_sic_codes() {
        return this.form.controls.company_sic_codes.value;
    }

    set company_sic_codes_all(val) {
        this.setValue('company_sic_codes_all', val);
    }

    get company_sic_codes_all() {
        return this.form.controls.company_sic_codes_all.value;
    }

    set company_sic_codes_any(val) {
        this.setValue('company_sic_codes_any', val);
    }

    get company_sic_codes_any() {
        return this.form.controls.company_sic_codes_any.value;
    }

    set company_sic_codes_none(val) {
        this.setValue('company_sic_codes_none', val);
    }

    get company_sic_codes_none() {
        return this.form.controls.company_sic_codes_none.value;
    }

    set company_naics_codes_any(val) {
        this.setValue('company_naics_codes_any', val);
    }

    get company_naics_codes_any() {
        return this.form.controls.company_naics_codes_any.value;
    }

    set include_primary_industry_only(val: boolean) {
        this.setValue('include_primary_industry_only', val);
    }

    get include_primary_industry_only() {
        return this.form.get('include_primary_industry_only').value;
    }

    set company_location_zipcodes(val) {
        this.setValue('company_location_zipcodes', val);
    }

    get company_location_zipcodes() {
        return this.form.controls.company_location_zipcodes.value;
    }

    set contact_location_zipcodes(val) {
        this.setValue('contact_location_zipcodes', val);
    }

    get contact_location_zipcodes() {
        return this.form.controls.contact_location_zipcodes.value;
    }

    set company_min_size(val) {
        this.setValue('company_min_size', val);
    }

    get company_min_size() {
        return this.form.controls.company_min_size.value;
    }

    set company_ids(val) {
        this.setValue('company_ids', val);
    }

    get company_ids() {
        return this.form.controls.company_ids.value;
    }

    set company_max_size(val) {
        this.setValue('company_max_size', val);
    }

    get company_max_size() {
        return this.form.controls.company_max_size.value;
    }

    set company_location_zipcodes_distance(val) {
        this.setValue('company_location_zipcodes_distance', val);
    }

    get company_location_zipcodes_distance() {
        return this.form.controls.company_location_zipcodes_distance.value;
    }

    set contact_location_zipcodes_distance(val) {
        this.setValue('contact_location_zipcodes_distance', val);
    }

    get company_score_min() {
      return this.form.controls.company_score_min.value;
    }

    set company_score_min(val: number) {
      this.setValue('company_score_min', val);
    }

    get company_score_max() {
      return this.form.controls.company_score_max.value;
    }

    set company_score_max(val: number) {
      this.setValue('company_score_max', val);
    }

    get icpintel_job_uuid() {
      return this.form.controls.icpintel_job_uuid.value;
    }

    set icpintel_job_uuid(val: string) {
      this.setValue('icpintel_job_uuid', val);
    }

    get contact_location_zipcodes_distance() {
        return this.form.controls.contact_location_zipcodes_distance.value;
    }

    set technographics(val) {
        this.setValue('technographics', val);
    }

    get technographics() {
        return this.form.controls.technographics.value;
    }

    set rankings(val) {
        this.setValue('rankings', val);
    }

    get rankings() {
        return this.form.controls.rankings.value;
    }

    set intent_topic_ids(val) {
        this.setValue('intent_topic_ids', val);
    }

    get intent_topic_ids() {
        return this.form.controls.intent_topic_ids.value;
    }

    set si_intent_topic_ids(val) {
        this.setValue('si_intent_topic_ids', val);
    }

    get si_intent_topic_ids() {
        return this.form.controls.si_intent_topic_ids.value;
    }

    set company_technographic_categories(val) {
        this.setValue('company_technographic_categories', val);
    }

    get company_technographic_categories() {
        return this.form.controls.company_technographic_categories.value;
    }

    set company_technographic_sub_categories(val) {
        this.setValue('company_technographic_sub_categories', val);
    }

    get company_technographic_sub_categories() {
        return this.form.controls.company_technographic_sub_categories.value;
    }

    set company_technographic_sub_categories_any(val) {
        this.setValue('company_technographic_sub_categories_any', val);
    }

    get company_technographic_sub_categories_any() {
        return this.form.controls.company_technographic_sub_categories_any.value;
    }

    set company_technographic_sub_categories_all(val) {
        this.setValue('company_technographic_sub_categories_all', val);
    }

    get company_technographic_sub_categories_all() {
        return this.form.controls.company_technographic_sub_categories_all.value;
    }

    set company_technographic_sub_categories_none(val) {
        this.setValue('company_technographic_sub_categories_none', val);
    }

    get company_technographic_sub_categories_none() {
        return this.form.controls.company_technographic_sub_categories_none.value;
    }

    set is_international(val) {
        this.setValue('is_international', val);
    }

    get is_international() {
        return this.form.controls.is_international.value;
    }

    set location_country_codes(val) {
        this.setValue('location_country_codes', val);
    }

    get location_country_codes() {
        return this.form.controls.location_country_codes.value;
    }

    set company_location_hq(val) {
        this.setValue('company_location_hq', val);
    }

    get company_location_hq() {
        return this.form.controls.company_location_hq.value;
    }

    set company_location_branch(val) {
        this.setValue('company_location_branch', val);
    }

    get company_location_branch() {
        return this.form.controls.company_location_branch.value;
    }

    set contact_revenue_max_identifier(val) {
        this.setValue('contact_revenue_max_identifier', val);
    }

    get contact_revenue_max_identifier() {
        return this.form.controls.contact_revenue_max_identifier.value;
    }

    set contact_revenue_min_identifier(val) {
        this.setValue('contact_revenue_min_identifier', val);
    }

    get contact_revenue_min_identifier() {
        return this.form.controls.contact_revenue_min_identifier.value;
    }

    set job_levels(val) {
        this.setValue('job_levels', val);
    }

    get job_levels() {
        return this.form.controls.job_levels.value;
    }

    set job_departments(val) {
        this.setValue('job_departments', val);
    }

    get job_departments() {
        return this.form.controls.job_departments.value;
    }

    set job_start_date(val) {
        this.setValue('job_start_date', val);
    }

    get job_start_date() {
        return this.form.controls.job_start_date.value;
    }

    set job_sub_departments(val) {
        this.setValue('job_sub_departments', val);
    }

    get job_sub_departments() {
        return this.form.controls.job_sub_departments.value;
    }

    set job_title(val) {
        this.setValue('job_title', val);
    }

    get job_title() {
        return this.form.controls.job_title.value;
    }

    set job_title_all(val) {
        this.setValue('job_title_all', val);
    }

    get job_title_all() {
        return this.form.controls.job_title_all.value;
    }

    set job_title_any(val) {
        this.setValue('job_title_any', val);
    }

    get job_title_any() {
        return this.form.controls.job_title_any.value;
    }

    set job_title_none(val) {
        this.setValue('job_title_none', val);
    }

    get job_title_none() {
        return this.form.controls.job_title_none.value;
    }

    set required_fields(val) {
        this.setValue('required_fields', val);
    }

    get required_fields() {
        return this.form.controls.required_fields.value;
    }

    set tiers(val) {
        this.setValue('tiers', val);
    }

    get tiers() {
        return this.form.controls.tiers.value;
    }

    set location_types(val) {
        this.setValue('location_types', val);
    }

    get location_types() {
        return this.form.controls.location_types.value;
    }

    set gte_last_modified_date(val) {
        this.setValue('gte_last_modified_date', val);
    }

    get gte_last_modified_date() {
        return this.form.controls.gte_last_modified_date.value;
    }

    set matchOnJobHistory(val) {
        this.setValue('matchOnJobHistory', val);
    }

    get matchOnJobHistory() {
        return this.form.controls.matchOnJobHistory.value;
    }

    set page(val) {
        this.setValue('page', val);
    }

    get page() {
        return this.form.controls.page.value;
    }

    set verified(val) {
        this.setValue('verified', val);
    }

    get verified() {
        return this.form.controls.verified.value;
    }

    set selected_boolean_operator(val) {
        this.setValue('selected_boolean_operator', val);
    }

    get selected_boolean_operator() {
        return this.form.controls.selected_boolean_operator.value;
    }

    set accuracy_tier_contact(val) {
        this.setValue('accuracy_tier_contact', val);
    }

    get accuracy_tier_contact() {
        return this.form.controls.accuracy_tier_contact.value;
    }

    set accuracy_tier_company(val) {
        this.setValue('accuracy_tier_company', val);
    }

    get accuracy_tier_company() {
        return this.form.controls.accuracy_tier_company.value;
    }

    set company_location_states(val) {
        this.setValue('company_location_states', val);
    }

    get company_location_states() {
        return this.form.controls.company_location_states.value;
    }

    set contact_location_states(val) {
        this.setValue('contact_location_states', val);
    }

    get contact_location_states() {
        return this.form.controls.contact_location_states.value;
    }

    set company_location_metro(val) {
        this.setValue('company_location_metro', val);
    }

    get company_location_metro() {
        return this.form.controls.company_location_metro.value;
    }

    set contact_location_metro(val) {
        this.setValue('contact_location_metro', val);
    }

    get contact_location_metro() {
        return this.form.controls.contact_location_metro.value;
    }

    set company_domains(val) {
        this.setValue('company_domains', val);
    }

    get company_domains() {
        return this.form.controls.company_domains.value;
    }

    set company_names(val) {
        this.setValue('company_names', val);
    }

    get company_names() {
        return this.form.controls.company_names.value;
    }

    set specialties(val) {
        this.setValue('specialties', val);
    }

    get specialties() {
        return this.form.controls.specialties.value;
    }

    set specialties_any(val) {
        this.setValue('specialties_any', val);
    }

    get specialties_any() {
        return this.form.controls.specialties_any.value;
    }

    set specialties_all(val) {
        this.setValue('specialties_all', val);
    }

    get specialties_all() {
        return this.form.controls.specialties_all.value;
    }

    set specialties_none(val) {
        this.setValue('specialties_none', val);
    }

    get specialties_none() {
        return this.form.controls.specialties_none.value;
    }

    set popular_keywords(val) {
        this.setValue('popular_keywords', val);
    }

    get popular_keywords() {
        return this.form.controls.popular_keywords.value;
    }

    set company_min_revenue(val) {
        this.setValue('company_min_revenue', val);
    }

    get company_min_revenue() {
        return this.form.controls.company_min_revenue.value;
    }

    set company_max_revenue(val) {
        this.setValue('company_max_revenue', val);
    }

    get company_max_revenue() {
        return this.form.controls.company_max_revenue.value;
    }

    set company_technographic_products_bool(val) {
        this.setValue('company_technographic_products_bool', val);
    }

    get company_technographic_products_bool() {
        return this.form.controls.company_technographic_products_bool.value;
    }

    set company_technographic_products_bool_tab(val) {
        this.setValue('company_technographic_products_bool_tab', val);
    }

    get company_technographic_products_bool_tab() {
        return this.form.controls.company_technographic_products_bool_tab.value;
    }

    set company_technographic_vendors_bool(val) {
        this.setValue('company_technographic_vendors_bool', val);
    }

    get company_technographic_vendors_bool() {
        return this.form.controls.company_technographic_vendors_bool.value;
    }

    set company_technographic_vendors_bool_tab(val) {
        this.setValue('company_technographic_vendors_bool_tab', val);
    }

    get company_technographic_vendors_bool_tab() {
        return this.form.controls.company_technographic_vendors_bool_tab.value;
    }

    set company_technographic_products(val) {
        this.setValue('company_technographic_products', val);
    }

    get company_technographic_products() {
        return this.form.controls.company_technographic_products.value;
    }

    set company_technographic_vendors(val) {
        this.setValue('company_technographic_vendors', val);
    }

    get company_technographic_vendors() {
        return this.form.controls.company_technographic_vendors.value;
    }

    set company_technographic_sub_categories_bool(val) {
        this.setValue('company_technographic_sub_categories_bool', val);
    }

    get company_technographic_sub_categories_bool() {
        return this.form.controls.company_technographic_sub_categories_bool.value;
    }

    set company_technographic_sub_categories_bool_tab(val) {
        this.setValue('company_technographic_sub_categories_bool_tab', val);
    }

    get company_technographic_sub_categories_bool_tab() {
        return this.form.controls.company_technographic_sub_categories_bool_tab.value;
    }

    set intent_minimum_score(val) {
        this.setValue('intent_minimum_score', val);
    }

    get intent_minimum_score() {
        return this.form.controls.intent_minimum_score.value;
    }

    set intent_maximum_score(val) {
        this.setValue('intent_maximum_score', val);
    }

    get intent_maximum_score() {
        return this.form.controls.intent_maximum_score.value;
    }

    set intent_topic_threshold(val) {
        this.setValue('intent_topic_threshold', val);
    }

    get intent_topic_threshold() {
        return this.form.controls.intent_topic_threshold.value;
    }

    set first_name(val) {
        this.setValue('first_name', val);
    }

    get first_name() {
        return this.form.controls.first_name.value;
    }

    set last_name(val) {
        this.setValue('last_name', val);
    }

    get last_name() {
        return this.form.controls.last_name.value;
    }

    set email(val) {
        this.setValue('email', val);
    }

    get email() {
        return this.form.controls.email.value;
    }

    set page_filters(val: IncludeExcludeFiltersModel) {
        this.setValue('page_filters', val);
    }

    get page_filters() {
        return this.form.controls.page_filters.value;
    }

    set owned_contacts_company(value: IncludeExcludeFiltersModel) {
        this.setValue('owned_contacts_company', value)
    }

    get owned_contacts_company() {
        return this.form.get('owned_contacts_company').value;
    }

    set owned_contacts_person(value: IncludeExcludeFiltersModel) {
        this.setValue('owned_contacts_person', value)
    }

    get owned_contacts_person() {
        return this.form.get('owned_contacts_person').value;
    }

    set department_size(value: DepartmentSizeFilterModel[]) {
        this.setValue('department_size', value)
    }

    get department_size() {
        return this.form.get('department_size').value;
    }

    set it_spend_super_category(value: string) {
        this.setValue('it_spend_super_category', value)
    }

    get it_spend_super_category() {
        return this.form.get('it_spend_super_category')?.value;
    }

    set it_spend_category(value: string) {
        this.setValue('it_spend_category', value)
    }

    get it_spend_category() {
        return this.form.get('it_spend_category')?.value;
    }

    set it_spend_sub_category(value: string[]) {
        this.setValue('it_spend_sub_category', value)
    }

    get it_spend_sub_category() {
        return this.form.get('it_spend_sub_category')?.value;
    }

    set min_it_spend_amount(value: number) {
        this.setValue('min_it_spend_amount', value)
    }

    get min_it_spend_amount() {
        return this.form.get('min_it_spend_amount')?.value;
    }

    set max_it_spend_amount(value: number) {
        this.setValue('max_it_spend_amount', value)
    }

    get max_it_spend_amount() {
        return this.form.get('max_it_spend_amount')?.value;
    }

    set min_last_funding_date(value: string) {
        this.setValue('min_last_funding_date', value);
    }
    get min_last_funding_date() {
        return this.form.get('min_last_funding_date')?.value;
    }

    set max_last_funding_date(value: string) {
        this.setValue('max_last_funding_date', value);
    }
    get max_last_funding_date() {
        return this.form.get('max_last_funding_date')?.value;
    }

    set last_funding_rounds(value: FundingRoundsEnum[]) {
        this.setValue('last_funding_rounds', value);
    }
    get last_funding_rounds() {
        return this.form.get('last_funding_rounds')?.value;
    }

    set funding_type(value: FundingFilterTypeEnum) {
        this.setValue('funding_type', value);
    }
    get funding_type() {
        return this.form.get('funding_type')?.value;
    }

    set min_funding_amount(value: number) {
        this.setValue('min_funding_amount', value);
    }
    get min_funding_amount() {
        return this.form.get('min_funding_amount')?.value;
    }

    set min_funding_amount_identifier(value: string) {
        this.setValue('min_funding_amount_identifier', value);
    }
    get min_funding_amount_identifier() {
        return this.form.get('min_funding_amount_identifier')?.value;
    }

    set max_funding_amount(value: number) {
        this.setValue('max_funding_amount', value);
    }
    get max_funding_amount() {
        return this.form.get('max_funding_amount')?.value;
    }

    set max_funding_amount_identifier(value: string) {
        this.setValue('max_funding_amount_identifier', value);
    }
    get max_funding_amount_identifier() {
        return this.form.get('max_funding_amount_identifier')?.value;
    }

    set last_funding_date(value: string) {
        this.setValue('last_funding_date', value);
    }
    get last_funding_date() {
        return this.form.get('last_funding_date')?.value;
    }

    set viDateFrom(val) {
        this.setValue('viDateFrom', val);
    }

    get viDateFrom() {
        return this.form.controls.viDateFrom.value;
    }

    set viDateTo(val) {
        this.setValue('viDateTo', val);
    }

    get viDateTo() {
        return this.form.controls.viDateTo.value;
    }

    set viSearchDurationType(val) {
        this.setValue('viSearchDurationType', val);
    }

    get viSearchDurationType() {
        return this.form.controls.viSearchDurationType.value;
    }

    set viUUID(val) {
        this.setValue('viUUID', val);
    }

    get viUUID() {
        return this.form.controls.viUUID.value;
    }

    reset(keys: string | string[]) {
        const keysArr: string[] = (isArray(keys) ? keys : [keys]) as string[];
        keysArr.forEach((key) => {
            this[key] = UniversalSearchModel[key];
        });
    }

    resetAll() {
        this.form.patchValue(UniversalSearchModel);
    }

    serialize() {
        return this.form.getRawValue();
    }

    private isEmptyField(val): boolean {
        if(val === '' || isUndefined(val) || isNull(val)) {
            return true;
        }
        return (isObject(val) || isArray(val)) && isEmpty(val);
    }

    omit() {
        const data = this.serialize();
        return omitBy(data, this.isEmptyField);
    }

    isEqual(obj, ignoredFields = ['request_type'], fieldsToSortBefore:string[] = []): boolean {
        return this.isFiltersEqual(this.serialize(), obj, ignoredFields, fieldsToSortBefore);
    }

    private checkSpecialConditions(filters1: any, filters2: any, field: string, specialValue: string): boolean {
        return (filters1[field] ?? '') !== (filters2[field] ?? '') &&
               ((filters1[field] ?? '') + (filters2[field] ?? '')) !== specialValue;
    }

    private normalizeCountryCodes(filters) {
        const countryCodes = filters['location_country_codes'] || [];
        const normalizedCodes = countryCodes.map(code => (code === 'GB' ? 'UK' : code));
        // @ts-ignore
        return [...new Set(normalizedCodes)];
    }

    isFiltersEqual(filters1, filters2, ignoredFields, fieldsToSortBefore: string[] = []): boolean {
        if (filters1 && filters2) {
            filters1['location_country_codes'] = this.normalizeCountryCodes(filters1);
            filters2['location_country_codes'] = this.normalizeCountryCodes(filters2);

            if ((this.checkSpecialConditions(filters1, filters2, 'accuracy_tier_contact', 'EV') ||
                this.checkSpecialConditions(filters1, filters2, 'accuracy_tier_company', 'MV'))) {
                return false;
            }
        }

        const omittedFilters1 = omit(omitBy(filters1, this.isEmptyField), ignoredFields);
        const omittedFilters2 = omit(omitBy(filters2, this.isEmptyField), ignoredFields);
        fieldsToSortBefore.forEach((field) => {
            if(isArray(omittedFilters1[field])) {
                omittedFilters1[field] = omittedFilters1[field].sort();
            }
            if(isArray(omittedFilters2[field])) {
                omittedFilters2[field] = omittedFilters2[field].sort();
            }
        })
        if (omittedFilters1['location_country_codes']?.join('') !== omittedFilters2['location_country_codes']?.join('')) {
            return false;
        }

        return isEqual(
            {...UniversalSearchModel, ...omittedFilters1},
            {...UniversalSearchModel, ...omittedFilters2}
        );
    }

    getValue() {
        return this.form.value;
    }

    get valueChanges() {
        return this.form.valueChanges;
    }

    patchValue(val) {
        return this.form.patchValue(val);
    }

    private createFormGroup(obj: any): FormGroup {
        const group = this.fb.group({});
        Object.keys(obj).forEach(key => {
            group.addControl(key, this.fb.control(obj[key]));
        });
        return group;
    }
}
